import React from 'react';
import { CollectionsProvider } from '@fiverr-private/collect_actions';
import { ListingsOrchestratorProvider } from '@fiverr-private/listings_orchestrator';
import { PricingProviderWithToast } from '../utils/priceUpfront/PricingProviderWithToast';
import { AppProvider, AppContext } from '../components/context/listingsContext';
import { ListingsImpressionProvider } from '../../../shared/context/ListingsImpressionContainer/ListingsImpressionContainer';
import { PAGE_NAME } from '../utils/constants';

const Store = ({ children, ...props }) => (
    <AppProvider {...props}>
        <PricingProviderWithToast
            priceUpfrontConfiguration={props.priceUpfrontConfiguration}
            priceUpfrontContext={props.priceUpfrontContext}
            isPriceUpfrontEnabled={props.isPriceUpfrontEnabled || false}
            priceUpfrontBuyableFeePolicy={props.priceUpfrontBuyableFeePolicy}
        >
            <ListingsOrchestratorProvider>
                <CollectionsProvider bi={{ source: PAGE_NAME }}>
                    <ListingsImpressionProvider onImpression={props.onImpression}>
                        {children}
                    </ListingsImpressionProvider>
                </CollectionsProvider>
            </ListingsOrchestratorProvider>
        </PricingProviderWithToast>
    </AppProvider>
);

export default Store;
export { AppContext };
